<template>
  <div class="ecm__detail-transaction section__padding">
    <div class="ecm__detail-transaction__container" v-if="order !== null">
      <p class="ecm__detail-transaction__container-title">Detail Transaction</p>
      <div class="ecm__detail-transaction__container_info">
        <div class="ecm__detail-transaction__container_info-left">
          <div class="ecm__detail-transaction__container_info-payment">
            <div class="ecm__detail-transaction__container_info-desc">
              <p class="key">Invoice</p>
              <span>:</span>
              <p class="value">{{ order.invoice }}</p>
            </div>
            <div class="ecm__detail-transaction__container_info-desc">
              <p class="key">Status</p>
              <span>:</span>
              <p class="value success" v-if="order.order_status === 'settlement'">Success</p>
              <p class="value pending" v-if="order.order_status === 'pending'">Pending</p>
              <p class="value expire" v-if="order.order_status === 'expire'">Expire</p>
            </div>
            <div class="ecm__detail-transaction__container_info-desc">
              <p class="key">Payment Date</p>
              <span>:</span>
              <p class="value">{{ formatDate(order.createdAt) }}</p>
            </div>
            <div class="ecm__detail-transaction__container_info-desc">
              <p class="key">Courier</p>
              <span>:</span>
              <p class="value">{{ order.courier_type }}</p>
            </div>
            <div class="ecm__detail-transaction__container_info-desc align-start">
              <p class="key">Address</p>
              <span>:</span>
              <div class="value">
                <p>{{ order.User_Address.receiver }}</p>
                <p>{{ order.User_Address.phone_number }}</p>
                <p>
                  {{ order.User_Address.detail_address }},
                  {{ order.User_Address.province }},
                  {{ order.User_Address.city }},
                  {{ order.User_Address.postal_code }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="ecm__detail-transaction__container_info-right">
          <div class="ecm__detail-transaction__container_info-desc justify-end">
            <p class="key">Payment Method</p>
            <p class="value">{{ order.payment_method }}</p>
          </div>
          <div class="ecm__detail-transaction__container_info-desc justify-end">
            <p class="key">Total Order</p>
            <p class="value">Rp {{ formatPrice(order.total_price) }}</p>
          </div>
          <div class="ecm__detail-transaction__container_info-desc justify-end">
            <p class="key">Cost</p>
            <p class="value">Rp {{ formatPrice(order.cost) }}</p>
          </div>
          <div v-if="order.order_status === 'pending'" class="ecm__detail-transaction__container_info-desc justify-end">
            <p class="key">Biller Code</p>
            <p class="value code">{{ order.biller_code }}</p>
          </div>
          <div v-if="order.order_status === 'pending'" class="ecm__detail-transaction__container_info-desc justify-end">
            <p class="key">Bill Key</p>
            <p class="value code">{{ order.bill_key }}</p>
          </div>
          <div class="ecm__detail-transaction__container_info-desc justify-end">
            <p class="key">Total</p>
            <p class="value big-font-size">Rp {{ formatPrice(order.cost + order.total_price) }}</p>
          </div>
          <button v-if="order.order_status === 'pending'" @click="$router.push('/payment-simulator')">Pay Now</button>
        </div>
      </div>
      <div class="ecm__detail-transaction__container_items">
        <div
          class="ecm__detail-transaction__container_items-item"
          v-for="(item) in order.Order_items" :key="item.id"
        >
          <div class="ecm__detail-transaction__container_items-item__cover">
            <img :src="item.Book.cover" alt="">
          </div>
          <div class="ecm__detail-transaction__container_items-item__desc">
            <p>{{ item.Book.title }}</p>
          </div>
          <div class="ecm__detail-transaction__container_items-item__price">
            <p>Rp {{ formatPrice(item.Book.price) }}</p>
          </div>
          <div class="ecm__detail-transaction__container_items-item__quantity">
            <p>{{ item.quantity }} Pcs</p>
          </div>
          <div class="ecm__detail-transaction__container_items-item__total">
            <p>Rp {{ formatPrice(item.Book.price * item.quantity) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import formatDisplay from '@/mixins/formatDisplay.js'
import SocketIo from '@/config/socket'

export default {
  name: 'Detail_Transaction',
  mixins: [formatDisplay],
  data () {
    return {
      socket: new SocketIo()
    }
  },
  mounted () {
    this.handleFetchOrder()
    this.socket.updateStatusTransaction(payload => {
      console.log(payload, 'masuk payload ku')
      this.handleFetchOrder()
    })
  },
  computed: {
    ...mapState({
      order: state => state.order.order
    })
  },
  methods: {
    ...mapActions({
      fetchOrder: 'order/fetchOrder'
    }),
    handleFetchOrder () {
      this.fetchOrder({ orderId: this.$route.params.id })
    },
    handleSocket () {
      this.socket.emitter('private-message', { message: 'hello world' })
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__detail-transaction {
  .ecm__detail-transaction__container {
    .ecm__detail-transaction__container-title {
      font-weight: 500;
      font-size: 20px;
      color: var(--color-blue);
      margin-bottom: 5px;
    }
    .ecm__detail-transaction__container_info {
      display: flex;
      justify-content: space-between;
      color: black;
      .ecm__detail-transaction__container_info-left {
        flex: .7;
        .ecm__detail-transaction__container_info-payment {
          padding: 10px;
          border: 1px solid rgba(128, 128, 128, 0.508);
          border-radius: 3px;
        }
      }
      .ecm__detail-transaction__container_info-right {
        flex: .3;
        margin-left: 20px;
        padding: 10px;
        border: 1px solid rgba(128, 128, 128, 0.508);
        border-radius: 3px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        min-height: 140px;
        max-height: 230px;
        button {
          margin-top: auto;
          padding: 7px;
          cursor: pointer;
          border: none;
          outline: none;
          border-radius: 3px;
          background: var(--color-blue-background);
          color: white;
          font-weight: 600;
          text-transform: uppercase;
          transition: .3s;
          &:hover {
            background: var(--color-blue);
          }
          &:disabled {
            cursor: not-allowed;
          }
        }
      }
      .ecm__detail-transaction__container_info-desc {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .key {
          width: 145px;
        }
        span {
          margin-right: 10px;
        }
        .value {
          width: 80%;
          &.pending,
          &.success,
          &.expire {
            font-size: 12px;
            width: auto;
            border-radius: 10px;
            padding: 1px 8px;
            color: white;
            font-weight: 500;
          }
          &.success {
            background: #34BD4A;
          }
          &.pending {
            background: #FDB400;
          }
          &.expire {
            background: rgb(253, 17, 17);
          }
          &.big-font-size {
            font-size: 25px;
            font-weight: 500;
            color: var(--color-pink);
          }
          &.code {
           color: var(--color-blue-background);
           font-weight: 600;
          }
        }
        &.align-start {
          align-items: flex-start;
        }
        &.justify-end {
          justify-content: space-between;
          .key {
            width: 140px;
          }
          .value {
            width: auto;
          }
        }
      }
    }
    .ecm__detail-transaction__container_items {
      margin-top: 20px;
      padding: 10px;
      border: 1px solid rgba(128, 128, 128, 0.508);
      border-radius: 3px;
      .ecm__detail-transaction__container_items-item {
        border-bottom: 1px solid rgba(0, 0, 0, 0.241);
        display: flex;
        &:last-child {
          border-bottom: 0;
        }
        .ecm__detail-transaction__container_items-item__cover {
          height: 90px;
          overflow: hidden;
          margin: 10px 0;
          background: red;
          img {
            height: 100%;
          }
        }
        .ecm__detail-transaction__container_items-item__desc,
        .ecm__detail-transaction__container_items-item__price,
        .ecm__detail-transaction__container_items-item__quantity,
        .ecm__detail-transaction__container_items-item__total {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 10px;
          flex: .1;
          font-weight: 500;
        }
        .ecm__detail-transaction__container_items-item__desc {
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          flex: .7;
        }
        .ecm__detail-transaction__container_items-item__price {
          p {
            color: var(--color-pink);
          }
        }
      }
    }
  }
}
</style>
